const BASE_ENLACE_GOOGLE = 'https://calendar.google.com/calendar/render?';
const BASE_ENLACE_YAHOO = 'https://calendar.yahoo.com/?';
const INICIO_CONTENIDO_ICS = 'data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0A';
const FIN_CONTENIDO_ICS = 'END:VEVENT%0AEND:VCALENDAR%0A';

export const generarEnlaceGoogle = (evento: any) => {
    const eventoInicio = formatearFecha(evento.inicio);
    let eventoFin = evento.fin ? formatearFecha(evento.fin) : undefined;
    if (!eventoFin) {
        const fechaFinEventoAllDay = new Date(evento.inicio);
        fechaFinEventoAllDay.setDate(fechaFinEventoAllDay.getDate() + 1);
        eventoFin = formatearFecha(fechaFinEventoAllDay);
    }
    const eventoGoogle = {
        action: "TEMPLATE",
        text: evento.titulo,
        details: evento.descripcion,
        dates: `${eventoInicio.substring(0, 15)}Z`+ '/' + `${eventoFin?.substring(0, 15)}Z`
    };
    return stringifyEnlace(BASE_ENLACE_GOOGLE, eventoGoogle);
};

export const generarEnlaceYahoo = (evento: any) => {
    evento.inicio.setHours(evento.inicio.getHours() + 2);
    evento.fin?.setHours(evento.fin.getHours() + 2);
    const eventoInicio = formatearFecha(evento.inicio);
    const eventoFin = evento.fin ? formatearFecha(evento.fin) : undefined;
    const eventoYahoo = {
        v: 60,
        title: evento.titulo,
        st: eventoInicio,
        et: evento.fin ? eventoFin : eventoInicio,
        desc: evento.descripcion,
        dur: !evento.fin ? 'allday' : undefined,
    };
    return stringifyEnlace(BASE_ENLACE_YAHOO, eventoYahoo);
};

export const generarEnlaceIcs = (evento: any) => {
    const eventoInicio = formatearFecha(evento.inicio);
    let eventoFin = evento.fin ? formatearFecha(evento.fin) : undefined;
    if (!eventoFin) {
        const fechaFinEventoAllDay = new Date(evento.inicio);
        fechaFinEventoAllDay.setDate(fechaFinEventoAllDay.getDate() + 1);
        eventoFin = formatearFecha(fechaFinEventoAllDay);
    }
    const eventoIcs = {
        DTSTART: `${eventoInicio.substring(0, 15)}Z`,
        DTEND: eventoFin ? `${eventoFin.substring(0, 15)}Z` : `${eventoInicio.substring(0, 15)}Z`,
        SUMMARY: evento.titulo,
        DESCRIPTION: evento.descripcion
    };
    return stringifyContenido(eventoIcs);
};

const stringifyEnlace = (baseUrl: string, evento: any) => {
    return Object.keys(evento).reduce((accum: string, el: string) => {
        return evento[el] ? `${accum}${el}=${encodeURI(evento[el])}&` : accum;
    }, baseUrl);
};

const stringifyContenido = (evento: any) => {
    const contenidoIcs = Object.keys(evento).reduce((accum: string, el: string) => {
        console.log(evento[el]);
        return `${accum}${el}:${evento[el]}%0A`;
    }, INICIO_CONTENIDO_ICS);
    return `${contenidoIcs}${FIN_CONTENIDO_ICS}`;
};

const formatearFecha = (fecha: Date) => {
    return fecha.toISOString().split(/[-.:]+/).join('');
};
